/**
 * Parse an opt-in boolean from an environment variable.
 *
 * Its own module, with no React Native or Expo imports, so it can be tested
 * directly in Node rather than asserted against as source text.
 *
 * Returns `undefined` for absent, empty, or unrecognised input so the caller
 * falls back to configuration instead of guessing. `EXPO_PUBLIC_*` values are
 * inlined by `expo export` at build time, so whatever this returns is baked
 * into the release.
 */
export function parseBoolEnv(raw: string | undefined): boolean | undefined {
  // Absent, empty and whitespace-only all fall through to `undefined` via the
  // final return — an empty variable is not a decision, it is the absence of
  // one. No separate check for them: a branch no test can distinguish from the
  // fallthrough is a branch that is not doing anything.
  const value = raw?.trim().toLowerCase();
  if (value === "true" || value === "1" || value === "yes") return true;
  if (value === "false" || value === "0" || value === "no") return false;
  return undefined;
}
